import { useQuery } from "react-query";
import { getAllApplications } from "../api/application";

export const useGetAllApplications = (options = {}) =>
  useQuery("getAllApplications", getAllApplications, options);

export default {
  useGetAllApplications,
};
